import { useSelectedBusiness } from "../../UserAccess/useSelectedBusiness";
import { HttpMethod } from "../../Common/useFetch";
import useUserRequest from "../../Common/useUserRequest";
import { RequestOptions } from "../../Common/useRequest";

export interface EmailConfigurationUpdate {
  orderTransactionsIsEnabled: boolean;
  orderTransactionsSendToCustomers: boolean;
  orderTransactionsSendToBranches: boolean;
  orderTransactionsSendToDrivers: boolean;
  orderTransactionsSendToCarriers: boolean;
  orderTransactionsSendToApplicators: boolean;
  connectorErrorsIsEnabled: boolean;
  connectorErrorsRecipients: string[],
}

const useUpdateEmailSettings = (options?: RequestOptions) => {
  const business = useSelectedBusiness();

  return useUserRequest<EmailConfigurationUpdate>({
    path: `/api/businesses/${business.id}/emailSettings`,
    method: HttpMethod.PUT,
  }, options);
}

export default useUpdateEmailSettings;
